"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeOutManager = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const initializer_1 = require("../../initializer");
const managerBase_1 = require("./managerBase");
const TimeOutManager = ({ config, timeout = initializer_1.TimeOut }) => {
    return (0, jsx_runtime_1.jsx)(managerBase_1.TimeOutManagerBase, { config: config, timeout: timeout });
};
exports.TimeOutManager = TimeOutManager;
//# sourceMappingURL=manager.js.map